import styled from 'styled-components';
import { Flex } from 'antd';

export const PageWrapperStyled = styled.div`
  padding: 32px 40px;
  background: ${p => p.theme?.colors?.light ?? '#f7f8fa'};
  min-height: 100%;
`;

export const SectionWrapperStyled = styled.div`
  margin-bottom: 32px;

  &:last-child {
    margin-bottom: 0;
  }
`;

export const SectionHeaderStyled = styled(Flex)`
  margin-bottom: 16px;
  gap: 8px;
`;

export const SectionTitleStyled = styled.span`
  letter-spacing: 0.08em;
  text-transform: uppercase;
  font-size: 12px;
  font-weight: 500;
`;

export const CardGridStyled = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 14px;
`;

export const CardIconWrapperStyled = styled(Flex)`
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: ${p => p.theme?.colors?.primary ?? '#0d7377'};
  color: white;
  font-size: 24px;
  margin-bottom: 12px;
`;
